var video = new function() {

    
    function video(settings) {
        
        var videosId = [];
        var settings = {
            video : '[data-video]',
            videoImageLoader : '[data-video-image-loader]',
            videoImage : '[data-video-image]',
            videoYoutubeId: '[data-video-youtube-id]',
            videoId: '[data-video-id]',
            videoMobileId: '[data-video-mobile-id]',
            bannerVideoButton: '[data-banner-video-button]'
        };


        var videoImageLoader = document.querySelectorAll(settings.videoImageLoader);
        if (videoImageLoader.length > 0) {
            for (var i = 0; i < videoImageLoader.length; i++) {
                var container = videoImageLoader[i].closest(settings.video);
                videoImageLoader[i].addEventListener("click", function() {
                    var video = container.querySelector(settings.videoId);
                    var videoYoutubeId = container.querySelector(settings.videoYoutubeId);
                    var videoMobile = container.querySelector(settings.videoMobileId);
                    var preload = container.querySelectorAll(".banner-video__preload");
                    var image = container.querySelector(settings.videoImage);

                    if (video != null) {
                        var id = video.dataset.videoId;
                        if (window.innerWidth < 800 && videoMobile != null) {
                            id = videoMobile.dataset.videoMobileId;
                        }

                        document.getElementById(id).play();

                        if (!videosId.includes(id)) {
                            videosId.push(id);

                            document.getElementById(id).addEventListener('play', function() {
                                preload.forEach((el) => {
                                    el.style.display = "none";
                                })
                                image.style.display = "none";
                                if (pageType == "product") fullscreen(id);
                            });
        
                            document.getElementById(id).addEventListener('pause', function() {
                                preload.forEach((el) => {
                                    el.style.display = "block";
                                })
                                image.style.display = "block";
                            });
        
                            document.getElementById(id).addEventListener('ended', function() {
                                preload.forEach((el) => {
                                    el.style.display = "block";
                                })
                                image.style.display = "block";
                                if (pageType == "product") exitFullscreen();
                            });

                        }
                    }
                    else if (videoYoutubeId.length != null) {
                        var id = videoYoutubeId.dataset.videoYoutubeId;
                        var symbol = videoYoutubeId.src.indexOf("?") > -1 ? "&" : "?";
                        videoYoutubeId.src += symbol + "autoplay=1";
                    }
                    preload.forEach((el) => {
                        el.style.display = "none";
                    })
                    image.style.display = "none";
                })
            }
        }
    }

    function fullscreen(id) {
        var elem = document.getElementById(id);
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        }
    }

    function exitFullscreen() {
        if (document.fullscreenElement) {
            document.exitFullscreen()
          }
    }

    return video;
}

video();
